import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchActivities } from '../../actions/activity';
import { ActivityProps } from '../../props/activity';
import ActivityOption from './ActivityOption';

import styles from './StewardAssetEditPage.scss';
import { getActivities } from '../../reducers/activities';

const propTypes = {
  activities: PropTypes.arrayOf(ActivityProps),
  value: PropTypes.shape({
    id: PropTypes.string,
    activities: PropTypes.arrayOf(PropTypes.shape({
      activityId: PropTypes.number,
      assetId: PropTypes.string,
      name: PropTypes.string
    }))
  }),
  activityType: PropTypes.string,
  assetDetails: PropTypes.shape({
    name: PropTypes.string,
    singular: PropTypes.string
  }),
  fetchActivities: PropTypes.func.isRequired
};

const defaultProps = {
  value: []
};

export class ActivitiesTab extends React.Component {
  componentDidMount() {
    this.props.fetchActivities();
  }

  render() {
    const { value: { id, activities: value}, activityType } = this.props;

    return (
      <div className={styles['activities-tab']}>
        {this.props.activities.map((activity) => (
          <ActivityOption
            key={`activity-${activity.id}`}
            assetId={id}
            activityType={activityType}
            activity={activity}
            value={value.find((record) => record.activityId === activity.id)} />
        ))}
      </div>
    );
  }
}

ActivitiesTab.propTypes = propTypes;
ActivitiesTab.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  activities: getActivities(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchActivities
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesTab);
